// @flow

import type { Tracker } from './combine'

let _fja
let type = 'react-app'

const tracker: Tracker = {
  init () {
    /* eslint-disable */
    eval(`window._fja = window._fja || {system_id: 'h5', source: 'h5'};
        window._fja.q = window._fja.q || [];
        (function () {
          var fjr = document.createElement('script');
          fjr.type = 'text/javascript';
          fjr.async = true;
          fjr.src = '//mws.fengjr.com/public/dist/mobile-web/js/analysis.min-2019-03-04.js';
          fjr.onload = function () {
            window._fja.init()
          }
          var s = document.getElementsByTagName('script')[0];
          s.parentNode.insertBefore(fjr, s);
        })()`);
    /* eslint-enable */
    _fja = window._fja
  },

  trackPageview (page?: string, prePage?: string) {
    _fja.q.push(['track_pageview', page, prePage])
  },

  trackEvent (name: string): void {
    _fja.q.push(['custom_event', { type, name }])
  },

  trackEventValue (name: string, value: string | {}) {
    if (typeof value === 'object') {
      _fja.q.push(['custom_event', { type, name, segments: value }])
    } else {
      _fja.q.push(['custom_event', { type, name, value }])
    }
  },

  setUid (uid: string) {
    _fja.q.push(['_setUserId', uid])
  },

  setCustomVar (key: string, value: string) {
    _fja.q.push([
      '_setProperty',
      key === 'channel' ? 'fjr_channel' : key,
      value
    ])
  }
}

export default tracker



// WEBPACK FOOTER //
// ./src/frame/core/analysis/fengjr.js